export const mockComments = [
  {
    id: 1,
    domainId: 1,
    username: "startupGuru",
    avatar: "https://i.pravatar.cc/150?img=8",
    text: "Great domain for a SaaS company! Should flip fast.",
    timestamp: "2024-01-15T12:00:00Z",
    likes: 5,
    likedBy: ["domainKing", "cryptoQueen"],
    replies: [
      {
        id: 101,
        username: "domainKing",
        avatar: "https://i.pravatar.cc/150?img=12",
        text: "Thanks! Open to reasonable offers.",
        timestamp: "2024-01-15T12:15:00Z",
        likes: 2,
        likedBy: []
      }
    ]
  },
  {
    id: 2,
    domainId: 1,
    username: "techPro",
    avatar: "https://i.pravatar.cc/150?img=15",
    text: "Seems a bit high for .io, but decent brand.",
    timestamp: "2024-01-15T11:30:00Z",
    likes: 3,
    likedBy: ["buyer123"],
    replies: []
  },
  {
    id: 3,
    domainId: 2,
    username: "aiEnthusiast",
    avatar: "https://i.pravatar.cc/150?img=11",
    text: "This is exactly what I've been looking for! AI domains are 🔥",
    timestamp: "2024-01-14T09:30:00Z",
    likes: 8,
    likedBy: ["domainKing", "cryptoQueen", "techPro"],
    replies: [
      {
        id: 102,
        username: "dataScientist",
        avatar: "https://i.pravatar.cc/150?img=9",
        text: "Agreed! AI keyword is super valuable right now.",
        timestamp: "2024-01-14T10:00:00Z",
        likes: 4,
        likedBy: []
      }
    ]
  },
  {
    id: 4,
    domainId: 2,
    username: "cryptoQueen",
    avatar: "https://i.pravatar.cc/150?img=5",
    text: "Premium .com with trending keyword. Worth every penny.",
    timestamp: "2024-01-13T16:45:00Z",
    likes: 12,
    likedBy: ["domainKing", "startupGuru", "techInvestor"],
    replies: []
  },
  {
    id: 5,
    domainId: 3,
    username: "buyer123",
    avatar: "https://i.pravatar.cc/150?img=3",
    text: "Would you accept a trade for TechNews.io?",
    timestamp: "2024-01-14T14:20:00Z",
    likes: 1,
    likedBy: [],
    replies: [
      {
        id: 103,
        username: "cryptoQueen",
        avatar: "https://i.pravatar.cc/150?img=5",
        text: "Possibly! Send me a formal trade offer.",
        timestamp: "2024-01-14T15:00:00Z",
        likes: 2,
        likedBy: []
      }
    ]
  },
  {
    id: 6,
    domainId: 4,
    username: "techInvestor",
    avatar: "https://i.pravatar.cc/150?img=6",
    text: "Love the .ai TLD. This will appreciate nicely.",
    timestamp: "2024-01-13T18:00:00Z",
    likes: 6,
    likedBy: ["dataScientist", "aiEnthusiast"],
    replies: []
  },
  {
    id: 7,
    domainId: 5,
    username: "healthTechPro",
    avatar: "https://i.pravatar.cc/150?img=13",
    text: "Perfect for a fitness app startup!",
    timestamp: "2024-01-12T10:15:00Z",
    likes: 4,
    likedBy: ["startupGuru"],
    replies: []
  },
  {
    id: 8,
    domainId: 6,
    username: "techPro",
    avatar: "https://i.pravatar.cc/150?img=15",
    text: "DevTools.com is a goldmine. Wish I had the budget!",
    timestamp: "2024-01-11T14:00:00Z",
    likes: 15,
    likedBy: ["domainKing", "startupGuru", "cryptoQueen"],
    replies: [
      {
        id: 104,
        username: "domainKing",
        avatar: "https://i.pravatar.cc/150?img=12",
        text: "It's a premium domain for sure. Feel free to make an offer!",
        timestamp: "2024-01-11T15:30:00Z",
        likes: 3,
        likedBy: []
      }
    ]
  },
];

export default mockComments;
